export default {
  clientToken: (state) => state.clientToken,
  refreshToken: (state) => state.refreshToken,
}
